import {TranslateService, TranslateLoader, TranslatePipe} from "ng2-translate/ng2-translate";
import {provide, PLATFORM_PIPES} from "@angular/core";
import {Observable} from "rxjs/Rx";

class StaticTranslateLoader extends TranslateLoader {
  getTranslation(lang:string):Observable<any> {
    var translations = require(`./translations-${lang}.config.yml`);
    return Observable.create(function (subscriber) {
      subscriber.next(translations);
      subscriber.complete();
    });
  }
}

export const TRANSLATOR_PROVIDERS = [
  provide(TranslateLoader, {
    useClass: StaticTranslateLoader,
  }),
  provide(PLATFORM_PIPES, {useValue: [TranslatePipe], multi: true}),
  TranslateService,
];



/** WEBPACK FOOTER **
 ** ./client/app/shared/translator/translate.service.ts
 **/